import { HttpAgentService } from './../../service/http-agent.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { AgentDto, AppRoleDto, DocumentDto, MsisdnDto, PartnerDto, ResultListDto, SearchResultDocumentDto } from '../../service/dto';
import { Filter, OnTableChange, TableColumn } from '../../components/table/table.component';
import { Router } from '@angular/router';
import { HttpSubscriberService } from '../../service/http-subscriber.service';
import { finalize } from 'rxjs';
import { HttpPartnerService } from '../../service/http-partner.service';
import { HttpAppRoleService } from '../../service/http-app-role.service';

@Component({
	selector: 'app-role-list',
	standalone: false,
	templateUrl: './role-list.component.html',
	styleUrl: './role-list.component.scss'
})
export class RoleListComponent implements OnInit, OnDestroy {
	results?: ResultListDto<AppRoleDto>;
	loading = false;

	columnRef: TableColumn[] = [
		{ "title": "Name", "property": "name" },
		{ "title": "Description", "property": "description" }
	];



	constructor(private service: HttpAppRoleService, private router: Router) {
	}

	ngOnInit(): void {
		this.doFetchResults({ filters: [], pageIndex: 0, pageSize: 1000 });
	}

	ngOnDestroy(): void {
	}

	trackByHashCode(index: number, item: SearchResultDocumentDto): any {
		return item.hashCode;
	}
	open(input: AppRoleDto){
		this.router.navigate(['/role','edit',input.id]);
	}

	doFetchResults(input: OnTableChange) {
		this.loading = true;
		this.service.getAll()
			.pipe(finalize(() => {
				this.loading = false;
			}))
			.subscribe(result => {
				this.results = {
					hashCode: 0,
					recordCount: result.length,
					pageLength: result.length,
					pageNumber: 0,
					pageCount: 1,
					records: result,
					filtersToOpen: true
				};
			});
	}
}
